module.exports = __webpack_public_path__ + "img/josechabebe.ca40a5d7.png";